import axiosInstance from './AxiosInstance';

export function getDashboards() {
    return axiosInstance.get(`dashboard`);
}


export function getBookings() {
    return axiosInstance.get(`bookings`);
}

export function createBooking(bookingData) {
    return axiosInstance.post(`/bookings`, bookingData);
}

export function updateBooking(bookingData) {
    return axiosInstance.put(`/bookings/${bookingData.id}`, bookingData);
}

export function deleteBookings(bookingId) {
    return axiosInstance.delete(`/bookings/${bookingId}`);
}

export function createPayment(paymentData) {
    return axiosInstance.post(`/booking-payment`, paymentData);
}

export function generateBill(billData) {
    return axiosInstance.post(`/bill`, billData);
}

export function getBills() {
    return axiosInstance.get(`/bills`);
}

export function saveBillPayment(paymentData) {
    return axiosInstance.post(`/bill-payment`, paymentData);
}
